<template>
  <div class="Container">
    <b-container>
      <h1>Terms and Conditions</h1>
      <b-container>
        <b-row>
          <p>
            The purpose of the Clarence device is to provide periodic data to
            the user, detailing the quality of the water tested by the unit.
          </p>

          <p>
            By clicking agree you hereby confirm that you accept the License
            Agreement and additionally grant permission to Angel Guard Limited
            to process the data from the device detailed above, in order to
            allow the device to function effectively.
          </p>
        </b-row>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  computed: {},
  components: {},

  data() {
    return {
      deviceLocation: "",
      devicePosition: "",
      deviceID: "",
      installerName: "",
      installDate: "",
      orderDate: "",
      orderFulfilledDate: "",
      deviceFeed: "",
      feedList: [],
      Positions: [],
      feedArray: [],
      PositionArray: [],
      CompanyName: [],
      inactiveDevice: [],
      deviceArray: [],
      LocationDrop: "",
      locationslist: [],
      locationsArray: [],
      newAddress: "",
      newEscalationEmail: "",
      newEscalationName: "",
      newDeptFloor: "",
      newArea: "",
      newLocation: "",
      newEscalationPhone: "",
      LogState: "",
      cookieAccept: "",
      insURN: this.$UserURN,
      userType: this.$ProfilePortal,
    };
  },

  beforeMount() {
    this.UserURNSubmit = this.$UserURN;

    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/userlookups";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "Consent",
      FirstName: "",
      LastName: "",
      UserType: this.userType,
      UserURN: this.UserURNSubmit,
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        this.cookieAccept = response.data.Values[0][0];
        localStorage.cookieAccept = this.cookieAccept;
        if (this.cookieAccept == "FALSE") {
          this.$refs["cookieModal"].show();
        }
      });
  },

  mounted() {
    this.CompanyName = this.$Company;
    this.installerName = this.$FullName;
    this.LogState = localStorage.getItem("Auth0loggedIn");

    if (this.LogState != "true") {
      this.$auth.login();
    }

    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "PositionFeed" };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        this.feedList = response.data.Feeds;
        this.Positions = response.data.Positions;
        for (let i = 0; i < this.feedList.length; i++) {
          var QuoteStr = this.feedList[i][0];
          this.feedArray.push({ id: QuoteStr, value: this.feedList[i][1] });
        }
        for (let i = 0; i < this.Positions.length; i++) {
          var QuoteStr2 = this.Positions[i][0];
          this.PositionArray.push({
            id: QuoteStr2,
            value: this.Positions[i][1],
          });
        }
      });

    let LookUpUrl2 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders2 = this.$apikeyPost;
    this.LookUpRequest2 = {
      RequestType: "DeviceComm",
      Company: this.CompanyName,
    };
    axios
      .post(LookUpUrl2, this.LookUpRequest2, LookUpHeaders2)
      .then((response) => {
        this.inactiveDeviceList = response.data.Values;
        for (let i = 0; i < this.inactiveDeviceList.length; i++) {
          var QuoteStr3 = this.inactiveDeviceList[i][0];
          this.deviceArray.push({
            id: QuoteStr3,
            value: this.inactiveDeviceList[i][1],
          });
        }
        this.inactiveDevice = this.deviceArray;
      });
    let LookUpUrl3 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders3 = this.$apikeyPost;
    this.LookUpRequest3 = {
      RequestType: "Location",
      Company: this.CompanyName,
    };
    axios
      .post(LookUpUrl3, this.LookUpRequest3, LookUpHeaders3)
      .then((response) => {
        response;
        this.locationslist = response.data.Values;
        for (let i = 0; i < this.locationslist.length; i++) {
          var QuoteStr4 = this.locationslist[i][0];
          this.locationsArray.push({
            id: QuoteStr4,
            location: this.locationslist[i][2],
            address: this.locationslist[i][1],
          });
        }
      });
  },

  methods: {
    showModal() {
      this.$refs["cookieModal"].show();
    },

    acceptModal() {
      this.cookieAccept = "TRUE";
      localStorage.cookieAccept = this.cookieAccept;
      this.LookUpRequest = {
        RequestType: "UpdateConsent",
        UserType: this.userType,
        UserDict: [{ UserURN: this.UserURNSubmit, ConsentGiven: "TRUE" }],
      };

      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/useradmin";
      let LookUpHeaders = this.$apikeyPost;

      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
        });

      this.$refs["cookieModal"].hide();
    },

    closeModal() {
      this.$refs["cookieModal"].hide();
    },

    CommissionDeviceModal() {
      this.$refs["termsModal"].show();
    },

    CommissionDevice() {
      this.CompanyName = this.$Company;
      this.$refs["termsModal"].hide();

      if (this.LocationDrop === "Existing Location") {
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/device";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "Commission",
          DeviceDict: [
            {
              DeviceID: this.deviceID.id,
              Location: this.deviceLocation.text,
              Position: this.devicePosition.id,
              Feed: this.deviceFeed.id,
              Company: this.CompanyName,
              InstalledDate: this.installDate,
              InstallerName: this.installerName,
              DisclaimerAgreed: "TRUE",
            },
          ],
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert("Device Commissioned");
            this.resetForm();
          });
      } else if (this.LocationDrop === "New Location") {
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/device";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "Commission",
          DeviceDict: [
            {
              DeviceID: this.deviceID.id,
              Location: "New",
              Position: this.devicePosition.id,
              Feed: this.deviceFeed.id,
              Company: this.CompanyName,
              InstalledDate: this.installDate,
              InstallerName: this.installerName,
              DisclaimerAgreed: "TRUE",
            },
          ],
          LocationDict: [
            {
              Address: this.newAddress,
              Location: this.newLocation,
              Area: this.newArea,
              DeptFloor: this.newDeptFloor,
              EscalationName: this.newEscalationName,
              EscalationEmail: this.newEscalationEmail,
              EscalationTel: this.newEscalationPhone,
              Company: this.CompanyName,
            },
          ],
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert("Device Commissioned");
            this.resetForm();
          });
      }
    },
    DeclineTerms() {
      this.$refs["termsModal"].hide();
      this.resetForm();
      alert("You have declined the Terms and Conditions");
    },
    resetForm() {
      this.deviceID = "";
      (this.deviceLocation = ""),
        (this.devicePosition = ""),
        (this.installDate = ""),
        (this.orderDate = ""),
        (this.orderFulfilledDate = ""),
        (this.deviceFeed = ""),
        (this.CompanyName = []),
        (this.LocationDrop = ""),
        (this.newAddress = ""),
        (this.newEscalationEmail = ""),
        (this.newEscalationName = ""),
        (this.newDeptFloor = ""),
        (this.newArea = ""),
        (this.newLocation = ""),
        (this.newEscalationPhone = "");
    },

    LogIn() {
      this.$auth.login();
    },
  },
};
</script>

<style>
input[type="text"],
input[type="date"],
select {
  width: 100%;
  margin: 2px 0;
  border-style: solid;
  padding: 2px 8px;
  position: relative;
  z-index: 0;
}
</style>
